import { createReducer, updateState } from '../handlers'
import types from './types'

const initialState = {
  schedule: []
}

const getSchedule = (state, action) => {
  const { schedule } = action
  
  return updateState(state, { schedule })
}
  
export default createReducer(initialState, {
  [types.GET_SCHEDULE]: getSchedule,
  [types.SAVE_SCHEDULE]: getSchedule
})